/**
 * Preset view for easily transforming/changing camera position to a specified position.
 */
var PresetView = /** @class */ (function () {
    /**
     * Create a preset view.
     * @param name Name of the preset view.
     * @param cameraPos Position to which the camera is to be set.
     * @param icon Icon of the preset view (to describe the view angle).
     */
    function PresetView(name, cameraPos, icon) {
        this.name = name;
        this.cameraPos = cameraPos;
        this.icon = icon;
    }
    /**
     * Get the URL of the preset view icon.
     * @returns Icon URL.
     */
    PresetView.prototype.getIconURL = function () {
        return 'assets/preset-views/' + this.icon + '.svg#' + this.icon;
    };
    return PresetView;
}());
export { PresetView };
//# sourceMappingURL=preset-view.model.js.map